import { jsPDF } from 'jspdf';
export const parseStringToHTML = (string) => {
    return string.replace('\n', '');
};
const htmlToPDFStyles = {
    h1: {
        fontSize: 24,
        fontStyle: 'bold',
        spacingBefore: index => (index === 0 ? 0 : 20),
        spacingAfter: 4
    },
    h2: {
        fontSize: 16,
        fontStyle: 'bold',
        spacingBefore: () => 16,
        spacingAfter: 16
    },
    h3: {
        fontSize: 12,
        fontStyle: 'bold',
        spacingBefore: () => 0,
        spacingAfter: 0
    },
    p: {
        fontSize: 12,
        fontStyle: 'normal',
        spacingBefore: () => 0,
        spacingAfter: 12
    },
    list: {
        fontSize: 12,
        fontStyle: 'normal',
        spacingBefore: () => 0,
        spacingAfter: 12
    }
};
export const parseStringToPDF = async (string) => {
    const serializeHTML = parseStringToHTML(string);
    const parser = new DOMParser();
    const doc = parser.parseFromString(serializeHTML, 'text/html');
    const pdf = new jsPDF({
        unit: 'pt',
        format: 'a4'
    });
    // Set default font
    pdf.setFont('times', 'normal');
    let yPosition = 40;
    const leftMargin = 40;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const maxWidth = pageWidth - 2 * leftMargin;
    const addWrappedText = (text, x, y, maxWidth, fontSize) => {
        pdf.setFontSize(fontSize);
        const lines = pdf.splitTextToSize(text, maxWidth);
        pdf.text(lines, x, y);
        return lines.length * fontSize * 1.2;
    };
    const handleElement = (element, index) => {
        const text = element.textContent?.trim() || '';
        if (!text)
            return 0;
        const tag = element.tagName.toLowerCase();
        const style = htmlToPDFStyles[tag] || htmlToPDFStyles.p;
        // Add spacing before
        yPosition += style.spacingBefore(index);
        // Set text style
        pdf.setFontSize(style.fontSize);
        pdf.setFont('times', style.fontStyle);
        // Handle lists specially
        if (tag === 'ul' || tag === 'ol') {
            const items = element.getElementsByTagName('li');
            Array.from(items).forEach((item, index) => {
                const bulletPoint = tag === 'ol' ? `${index + 1}.` : '•';
                const itemText = item.textContent?.trim() || '';
                const lines = pdf.splitTextToSize(itemText, maxWidth);
                if (yPosition + lines.length * style.fontSize * 1.2 >= pdf.internal.pageSize.getHeight() - 40) {
                    pdf.addPage();
                    yPosition = 40;
                }
                yPosition += addWrappedText(`${bulletPoint} ${itemText}`, leftMargin + 10, yPosition, maxWidth - 20, style.fontSize);
                yPosition += 8;
            });
        }
        else {
            const lines = pdf.splitTextToSize(text, maxWidth);
            if (yPosition + lines.length * style.fontSize * 1.2 >= pdf.internal.pageSize.getHeight() - 40) {
                pdf.addPage();
                yPosition = 40;
            }
            yPosition += addWrappedText(text, leftMargin, yPosition, maxWidth, style.fontSize);
        }
        // Add spacing after
        yPosition += style.spacingAfter;
        // Handle pagination
        if (yPosition >= pdf.internal.pageSize.getHeight() - 40) {
            pdf.addPage();
            yPosition = 40;
        }
    };
    // Process elements
    Array.from(doc.body.children).forEach((element, index) => {
        handleElement(element, index);
    });
    return pdf.output('blob');
};
